import React, { useContext } from "react";
import { SliderContext } from "./App";
import { AppContext } from "../window";
import { useTranslation } from "../i18n";
import Pictures from "../user/Pictures";

interface NoPictureModalProps {
  onPictureUploaded?: () => void;
}

export const NoPictureModal: React.FC<NoPictureModalProps> = ({ onPictureUploaded }) => {
  const { t } = useTranslation();
  const { texts } = useContext(AppContext);
  const { setModal } = useContext(SliderContext);

  return (
    <div className="no-picture">
      <div className="text-center mb-3">
        <h4>{t('slider.upload_picture_required')}</h4>
        <p className="mb-3">{t('slider.no_picture_message')}</p>
      </div>
      
      <div className="pictures-container">
        <Pictures onPictureUploaded={onPictureUploaded} />
      </div>
      
      <div className="text-center">
        <button 
          className="btn btn-secondary px-4"
          onClick={() => setModal(undefined)}
        >
          {t('slider.cancel')}
        </button>
      </div>
    </div>
  );
};
